import { useTranslation } from "react-i18next";
import { Lock, Mail } from "lucide-react";
import { AppLayout } from "@/components/AppLayout";
import { Button } from "@/components/ui/button";

const SALES_EMAIL = "sales@besthr.app";

/**
 * Shown when a user navigates to a route whose module is disabled for the
 * tenant. Renders inside AppLayout so the sidebar/header remain available.
 */
export default function ModuleDisabled() {
  const { t } = useTranslation();

  return (
    <AppLayout>
      <div className="flex flex-1 items-center justify-center py-16">
        <div className="max-w-md w-full text-center rounded-2xl border border-border bg-card shadow-card px-8 py-10">
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
            <Lock className="h-7 w-7 text-primary" />
          </div>
          <h1 className="text-xl font-bold text-foreground">
            {t("moduleDisabled.title", "This module isn't enabled")}
          </h1>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
            {t(
              "moduleDisabled.description",
              "This module is not enabled for your organization. Contact our team to discuss how to enable it.",
            )}
          </p>
          <Button asChild className="mt-6">
            <a href={`mailto:${SALES_EMAIL}`}>
              <Mail className="h-4 w-4" />
              {t("moduleDisabled.contact", "Contact {{email}}", { email: SALES_EMAIL })}
            </a>
          </Button>
        </div>
      </div>
    </AppLayout>
  );
}
